/**
 * MyBookmark
 */

import List from '../List';
import Config from '../../Config';

class MyBookmark extends List {
  constructor(node: any, options: any) {
    Config.isShowSearchForm = false;
    Config.isWrite = false;
    Config.isShowReload = false;

    super(node, options);

    const configL10N = Config.L10N;
    configL10N.btn_delete = configL10N.btn_bookmark_delete;
    configL10N.alert_delete_article = configL10N.alert_delete_bookmark;
  }

  public get(apiUrl: string) {
    const url = (apiUrl)? apiUrl : Config.isInfinite ? Config.moreScrapList() : Config.scrapList();
    super.get(url);
  }
}

export default MyBookmark;
